import {Routes} from '@angular/router';
import {CreatePageComponent} from './create-page.component';
import {AuthGuard} from '../../../../guards/auth.guard';
import {IsCompletedUserDataGuard} from '../../../../guards/is-completed-user-data.guard';
import {responseToCallRoutes} from '../response-to-call/response-to-call.routes';
import {generalLetterRoutes} from '../general-letter/general-letter.routes';
import {documentsInformationRoutes} from '../documents-information/documents-information.routes';
import {forestTaxLi1Routes} from '../forest-tax-li-1.routes';
import {forestTaxDl1Routes} from '../forest-tax-dl-1.routes';
import {propertyTaxIn1Routes} from '../property-tax-in-1.routes';
import {propertyTaxDn1Routes} from '../property-tax-dn-1.routes';
import {agriculturalTaxIr1Routes} from '../agricultural-tax-ir-1.routes';
import {agriculturalTaxDr1Routes} from '../agricultural-tax-dr-1.routes';
import {meansOfTransportTaxDt1Routes} from '../means-of-transport-tax-dt-1.routes';
import {municipalWasteDisposalRoutes} from '../municipal-waste-disposal/municipal-waste-disposal.routes';
import {alcoholicSalesPermitRoutes} from '../ alcoholic-sales-permit/ alcoholic-sales-permit.routes';
import {contactDataUpdateRoutes} from "../contact-data-update/contact-data-update.routes";
import {realEstateLeasingRoutes} from "../real-estate-leasing/real-estate-leasing.routes";
import {perpetualUsufructRoutes} from "../perpetual-usufruct/perpetual-usufruct.routes";

export const applicationCreatePageRoutes: Routes = [
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odpowiedz-na-wezwanie/skladanie-wniosku',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uzupelnienie-dokumentow/skladanie-wniosku',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/pismo-ogolne/skladanie-wniosku',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-lesny-il-1/skladanie-wniosku',
    children: forestTaxLi1Routes,
    data: {
      contentUrl: 'podatek-lesny-il-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-lesny-dl-1/skladanie-wniosku',
    children: forestTaxDl1Routes,
    data: {
      contentUrl: 'podatek-lesny-dl-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-od-nieruchomosci-in-1/skladanie-wniosku',
    children: propertyTaxIn1Routes,
    data: {
      contentUrl: 'podatek-od-nieruchomosci-in-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-od-nieruchomosci-dn-1/skladanie-wniosku',
    children: propertyTaxDn1Routes,
    data: {
      contentUrl: 'podatek-od-nieruchomosci-dn-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-rolny-ir-1/skladanie-wniosku',
    children: agriculturalTaxIr1Routes,
    data: {
      contentUrl: 'podatek-rolny-ir-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-rolny-dr-1/skladanie-wniosku',
    children: agriculturalTaxDr1Routes,
    data: {
      contentUrl: 'podatek-rolny-dr-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/podatek-od-srodki-transportowe-dt-1/skladanie-wniosku',
    children: meansOfTransportTaxDt1Routes,
    data: {
      contentUrl: 'podatek-od-srodki-transportowe-dt-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wywoz-odpadow-komunalnych/skladanie-wniosku',
    children: municipalWasteDisposalRoutes,
    data: {
      contentUrl: 'wywoz-odpadow-komunalnych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zezwolenie-sprzedaz-napojow-alkoholowych/skladanie-wniosku',
    children: alcoholicSalesPermitRoutes,
    data: {
      contentUrl: 'zezwolenie-sprzedaz-napojow-alkoholowych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/aktualizacja-danych-kontaktowych-wpio-20/skladanie-wniosku',
    children: contactDataUpdateRoutes,
    data: {
      contentUrl: 'aktualizacja-danych-kontaktowych-wpio-20'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wydzierzawienie-nieruchomosci/skladanie-wniosku',
    children: realEstateLeasingRoutes,
    data: {
      contentUrl: 'wydzierzawienie-nieruchomosci'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wieczyste-uzytkowanie/skladanie-wniosku',
    children: perpetualUsufructRoutes,
    data: {
      contentUrl: 'wieczyste-uzytkowanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
];
